const mobileReg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
// 密码强度校验  至少6位 且至少包含数字和字母
const passwordValidReg = /(?=.*[0-9])(?=.*[a-zA-Z])^.{6,32}$/;

const validInt = /^(?:0|[1-9][0-9]{0,1}|100)$/; // 0 - 100 的整数

export { mobileReg, passwordValidReg, validInt };
